/**
 * Maps fuel names to their corresponding icons.
 * Organized by region (NA/EU).
 */
export const FUEL_ICON_MAP: Record<string, string> = {
  // NA Fuels
  NA_DIESEL: '/assets/diesel.svg',
  NA_GAS: '/assets/gas.svg',

  // EU Fuels
  EU_MILES_DIESEL: '/assets/diesel.svg',
  EU_MILESPLUS_DIESEL: '/assets/miles-plus-diesel.svg',
  EU_SUPRAGAZ: '/assets/supergaz.svg',
  EU_MILES_95: '/assets/miles-95.svg',
  EU_MILESPLUS_95: '/assets/miles-95.svg',
  EU_ADBLUE: '/assets/ad-blue.svg',
};
